<template>
  <div :class="divValueStyle">
    <div :class="oneLine ? 'col-6' : 'col-12'">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight"
        :class="labelStyle ? labelStyle : 'text-muted'"
      >
        {{ $t(i18nKey) }}
      </label>
    </div>
    <div :class="oneLine ? 'col-6' : 'col-12'">
      <span class="font-weight margin-left color" :class="valueStyle">
        {{ value }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: ["i18nKey", "value", "labelStyle", "valueStyle", "oneLine", "divValueStyle"],
})
export default class LabelAndValue extends Vue {
  i18nKey?: string;
  value?: string;
  labelStyle?: any;
  valueStyle?: any;
  divValueStyle?: any;
  oneLine?: boolean;
}
</script>
